import isUrl from 'is-url';

const getLastImageUrl = (urls) => {
  if (!urls || urls.filter(Boolean).length === 0) {
    return null;
  }
  return urls.at(-1);
};

const getJobMediaUrl = (imageUrls, logoUrls, origin) => {
  const imageUrl = getLastImageUrl(imageUrls);
  const logoUrl = getLastImageUrl(logoUrls);

  const url = logoUrl ?? imageUrl;

  if (!url) {
    return null;
  }

  return isUrl(url) ? url : `${origin}${url}`;
};

export default getJobMediaUrl;
